<template>
  <div class="comments-list">

    <comments-list-item v-for="(item, index) in list"
                        :key="index"
                        :comment="item" />

    <infinite-loading :identifier="infiniteId"
                      @infinite="load">
      <div slot="no-results">{{$t('message.generics.message.noResultsFound')}}</div>
      <div slot="no-more"></div>
    </infinite-loading>

  </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import CommentsListItem from '@components/modules/comments/CommentsListItem';
    import EventBus from "@packages/event-bus";

    export default {
        components: {
            CommentsListItem,
            InfiniteLoading
        },

        data() {
            return {
                entity: 'comments',
                loadOnFilters: false,
                infiniteId: +new Date(),
                page: 0,
                loading: false,
                list: []
            }
        },

        computed: {
          hasItems() {
            return this.list && !!this.list.length
          },
          filters() {
              return this.$store.state.comments.filters;
          },
        },

        methods: {
          commentsLoadHandler() {
            this.list = []
            this.page = 0
            this.infiniteId++
          },
          async load($state) {
            this.loading = true;

            const nextPageList = await this.$api.comments.list({ page: this.page, filters: this.filters });

            if(nextPageList.length) {
              this.page += 1;

              this.list.push(...nextPageList);

              if($state) {
                $state.loaded();
              }

            } else {
              if($state) {
                $state.complete();
              }
            }

            this.loading = false;
          },
        },

        mounted() {
          EventBus.$on('COMMENTS_LOAD', this.commentsLoadHandler);
        },

        beforeDestroy() {
          EventBus.$off('COMMENTS_LOAD', this.commentsLoadHandler);
          this.$store.commit('COMMENTS_RESET_FILTERS')
        },


    }
</script>

<style lang="scss" scoped>
.comments-list {
  .loading {
    margin: 0 auto;
  }

  .comments-list-empty {
    text-align: center;
    color: #707070;
  }
}
</style>
